import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex text-xs justify-between items-center" }
const _hoisted_4 = { class: "flex text-xs justify-start items-center mb-s" }
const _hoisted_5 = { class: "pl-2 text-xl font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "text-gray-600 text-xl font-semibold" }

import { computed, ref, nextTick } from "vue";
import { Conversation } from "@/interfaces/conversation";
import { shortLocaleString } from "@/helpers/datehelper";
import { Message } from "@/interfaces/message";
import RoundedCard from "@/components/RoundedCard.vue";
import {
  nameFromUid,
  profileFromUid,
} from "@/helpers/requestHelpers/publicDataRequests";
import { encryptAndSaveMessage } from "@/helpers/requestHelpers/ordersRequests";
import { supabase } from "@/helpers/supabase";
import { useSessionStore } from "@/store/sessionStore";
import { usePublicStore } from "@/store/publicStore";
import ProfileCircle from "@/components/ProfileCircle.vue";
import IconButton from "@/components/IconButton.vue";
import EmptyContainer from "@/components/EmptyContainer.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { useNotificationStore } from "@/store/notificationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderChat',
  props: {
    messages: {},
    conversation: {}
  },
  setup(__props: any) {

const sessionStore = useSessionStore();
const publicStore = usePublicStore();

const chatDiv = ref<HTMLDivElement | null>(null);
const message = ref("");
let readMessages = 0;

const props = __props;

const chatMessages = computed(() => {
  nextTick(() => {
    if (chatDiv.value) {
      chatDiv.value.scrollTop = 0;
    }
  });
  let newestMessage = props.messages.at(-1);
  if (
    newestMessage !== undefined &&
    newestMessage.id > Math.max(readMessages, props.conversation.read ?? 0)
  ) {
    setRead(newestMessage.id);
    readMessages = newestMessage.id;
  }
  return props.messages.filter((message) => message.type == 0).reverse();
});

async function setRead(newestMessageId: number) {
  if (sessionStore.selectedCareProviderGroup != null) {
    await supabase.from("orders_conversation_status").upsert({
      conversation_id: props.conversation.id,
      care_provider_group_id: sessionStore.selectedCareProviderGroup.id,
      read_message_id: newestMessageId,
    });
  }
}
async function sendChatMessage() {
  useNotificationStore().notifications =
    useNotificationStore().notifications.filter(
      (not) => not.customId != "chat"
    );
  if (message.value.length < 2) {
    useNotificationStore().notifications.push({
      msg: `Mindestlänge einer Nachricht beträgt 2 Zeichen. #ch01`,
      type: "warning",
      customId: "chat",
    });
    return;
  }
  try {
    await encryptAndSaveMessage(props.conversation, {
      decrypted_message: message.value,
      type: 0,
    });
    message.value = "";
  } catch (e) {
    console.error(e);
  }
  window._paq.push([
    "trackEvent",
    "Chat",
    "chatmessage - sent, length",
    message.value.length,
  ]);
}

function isSenderCareProviderGroupOf(message: Message) {
  return (
    message.sender_care_provider_group_id ==
    sessionStore.selectedCareProviderGroup?.id
  );
}

function careProviderGroupName(id: number) {
  return (
    publicStore.careProviderGroups?.find((el) => el.id == id)?.group_name ??
    "Fehler"
  );
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UmanaHeadline, {
      h: "h2",
      class: "p-xs"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Chat")
      ]),
      _: 1
    }),
    (props.messages != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "h-full overflow-scroll flex flex-col-reverse",
          ref_key: "chatDiv",
          ref: chatDiv
        }, [
          (chatMessages.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(EmptyContainer, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Senden Sie die erste Chat-Nachricht")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatMessages.value, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `msg_${message.id}`,
              class: "mb-l pb-s"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(ProfileCircle, {
                    profile: _unref(profileFromUid)(message.created_by) ?? undefined
                  }, null, 8, ["profile"]),
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(nameFromUid)(message.created_by)), 1),
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(careProviderGroupName(message.sender_care_provider_group_id)), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(shortLocaleString)(message.created_at)), 1)
              ]),
              _createVNode(RoundedCard, {
                color: isSenderCareProviderGroupOf(message) ? 'white' : 'green',
                class: "whitespace-pre-wrap"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(message.decrypted_message), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]))
          }), 128))
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_FormKit, {
      type: "form",
      actions: false,
      onSubmit: sendChatMessage,
      class: "mt-5",
      "wrapper-class": "h-textarea"
    }, {
      default: _withCtx(() => [
        _createVNode(RoundedCard, {
          color: "gray",
          class: "flex items-end mb-xs pb-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              type: "textarea",
              placeholder: "Schreiben Sie Ihre Nachricht...",
              modelValue: message.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(IconButton, {
              icon: "right",
              class: "ml-xs mb-4",
              onClick: sendChatMessage
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})